
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/f/custody-whitepaper/t",
      function () {
        return require("private-next-pages/f/custody-whitepaper/t.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/f/custody-whitepaper/t"])
      });
    }
  